import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  const location = useLocation();

  // A page view when the page changes - not for a new history entry of the
  // same URL (the dashboard keeps one to hold the Back button in the app).
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);
};

export default usePageTracking;
